<!-- my-investments-refund.component.html -->
<div class="pitchin-icon pitchin-icon-close" (click)="closeModal()"></div>
<div class="modal-header">
    <h5 class="modal-title">{{ 'investment.refundConfirmBankDetails' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="px-3 pb-2 text-muted small">
    <ng-container *ngIf="paymentMethod?.accountHolder && paymentMethod?.accountNumber; else noBankDetails">
        {{ 'investment.refundPrefilledNote' | translate }}
    </ng-container>
    <ng-template #noBankDetails>
        {{ 'investment.refundProvideNote' | translate }}
    </ng-template>
</div>

<div class="modal-body">
    <div class="mb-3">
        <label class="form-label">{{ 'investment.bankName' | translate }} *</label>
        <select class="form-control" [(ngModel)]="bankId">
            <option value="">{{ 'investment.selectBank' | translate }}</option>
            <option *ngFor="let bank of bankList" [value]="bank.id">
                {{ bank.name }}
            </option>
        </select>
    </div>

    <div class="mb-3">
        <label class="form-label">{{ 'investment.accountHolderName' | translate }} *</label>
        <input type="text" class="form-control" [(ngModel)]="accountHolder">
    </div>

    <div class="mb-3">
        <label class="form-label">{{ 'investment.accountNumber' | translate }} *</label>
        <input type="text" class="form-control" [(ngModel)]="accountNumber">
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">{{ 'common.cancel' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="saveRefundDetails()">{{ 'common.save' | translate }}</button>
</div>
